'use client';

import breakpoints from '@carvana/merch-tailwind/breakpoints';
import cx from 'classnames';
import { appAssetsCdnUrl } from '~/constants/environment';
import toLowerKebabCase from '~/utilities/toLowerKebabCase';
import GeolocationButton from './GeolocationButton';
import {
  GoldText,
  Heading,
  HeroWrapper,
  Subtitle,
  TextContent
} from './Hero.styles';

const makeIconStyles: Record<string, string> = {
  Chrysler:
    'w-[191px] sm:w-[250px] md:w-[302px] mr-[18px] sm:mr-[60px] lg:mr-[133px]',
  Dodge:
    'w-[196px] sm:w-[250px] md:w-[380px] mr-[18px] sm:mr-[30px] md:mr-[15px] lg:mr-[89px]',
  Jeep: 'w-[140px] sm:w-[180px] md:w-[230px] mr-[45px] md:mr-[110px] lg:mr-[206px]',
  Ram: 'w-[70px] sm:w-[100px] md:w-[175px] mb-[25px] mr-[55px] md:mr-[110px] lg:mr-[200px]'
};

const defaultIconStyle = 'w-[140px] sm:w-[180px] md:w-[230px]';

type OwnProps = {
  make: string;
};

export default function MakeHero({ make }: OwnProps) {
  const iconStyle = makeIconStyles[make] ?? defaultIconStyle;
  const heroBackgroundMobileSrc = `${appAssetsCdnUrl}/images/new-car/hero-make-background-small.svg`;
  const heroBackgroundDesktopSrc = `${appAssetsCdnUrl}/images/new-car/hero-make-background-large.svg`;

  return (
    <HeroWrapper data-testid="hero">
      <picture aria-hidden="true">
        <source
          media={`(min-width: ${breakpoints.md}px)`}
          srcSet={heroBackgroundDesktopSrc}
        />
        <img
          alt=""
          className="absolute inset-0 size-full object-cover object-[center_70%] md:object-[53%_80%]"
          src={heroBackgroundMobileSrc}
        />
      </picture>
      <TextContent>
        <Heading>
          Find your perfect <GoldText>{make}</GoldText>
        </Heading>
        <Subtitle className="max-w-full">
          All brand new models — pickup or delivery as soon as today!
        </Subtitle>
        <GeolocationButton />
      </TextContent>
      <div className="absolute bottom-0 right-0 z-10 flex items-center justify-center md:top-1/2 md:bottom-auto md:-translate-y-1/2">
        <img
          alt={`${make} logo`}
          className={cx('block object-contain', iconStyle)}
          src={`${appAssetsCdnUrl}/images/new-car/${toLowerKebabCase(
            make
          )}/hero-icon.svg`}
        />
      </div>
    </HeroWrapper>
  );
}
